import { render } from "./SignUpAccount.vue?vue&type=template&id=6349dd58&scoped=true&ts=true"
import script from "./SignUpAccount.vue?vue&type=script&lang=ts"
export * from "./SignUpAccount.vue?vue&type=script&lang=ts"

import "./SignUpAccount.vue?vue&type=style&index=0&id=6349dd58&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Anton\\Workspaces\\htdocs\\devloader-userspace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6349dd58"]])

export default __exports__